import { AvailityServiceReviewConfiguration, Checklist } from "risa-data-model";
import { FormQuestions as APIFormQuestions } from "../../data-model/formQuestions";
import { ApiBaseUrls } from "../../enums/apiUrls";
import { logDataToConsole, logError } from "../../utils/customLogger";
import { isProduction } from "../../utils/runtimeEnv";
import { FirestoreService } from "../firebase/firestoreService";
import {
  FirestoreCollectionReference,
  FirestoreDocumentReference,
} from "../firebase/references";
import { getBearerToken } from "./bearerToken";

export const makePostCallToCohereWithQuestionnaireFilled = async (
  id: string,
  questionsWithResponse: Checklist[],
  availityConfigurationDocRef: AvailityServiceReviewConfiguration,
) => {
  try {
    await updateQuestionnaireInFirestore(id, questionsWithResponse);

    const { questionnaireDocRef } = await fetchDocumentsFromFirestore(id);

    const payload = createPayload(
      id,
      questionnaireDocRef,
      availityConfigurationDocRef,
    );

    logDataToConsole("Payload for background submission", payload);

    const token = await getBearerToken();
    if (!token) return;
    await makePostRequest(payload, token);
  } catch (error) {
    logError(
      error as Error,
      "Error in makePostCallToCohereWithQuestionnaireFilled",
    );
  }
};

const updateQuestionnaireInFirestore = async (
  id: string,
  questionsWithResponse: Checklist[],
) => {
  await FirestoreService.updateDocument(
    FirestoreCollectionReference.formQuestionnaire(id),
    "questionnaire",
    {
      "questions.value": questionsWithResponse,
    },
  );
};

const fetchDocumentsFromFirestore = async (id: string) => {
  const questionnaireDocRef =
    await FirestoreService.getDocument<APIFormQuestions>(
      FirestoreDocumentReference.formQuestionnaire(id),
    );

  return { questionnaireDocRef };
};

const createPayload = (
  id: string,
  questionnaireDocRef: APIFormQuestions,
  availityServiceReviewConfigurationDocRef: AvailityServiceReviewConfiguration,
) => {
  return {
    orderId: id,
    availityServiceReviewConfiguration:
      availityServiceReviewConfigurationDocRef,
    questionnaire: {
      questions: questionnaireDocRef.questions,
    },
  };
};

const makePostRequest = async (payload: any, token: string) => {
  const response = await fetch(
    isProduction()
      ? ApiBaseUrls.PROD_SUBMI_PA_FORM
      : ApiBaseUrls.DEV_SUBMI_PA_FORM,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    },
  );

  if (!response.ok) {
    logError(new Error("Background submission failed"), response.statusText);
  } else {
    logDataToConsole("Submission successfull", response);
  }
};
